import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Reward Cards',
  content: [
    'In most cases, reward cards such as Blue Rewards, Aeroplan, PC Optimum and Canadian Tire "Money"',
    'card can be replaced by contacting the issuer. It is advisable to alert the program',
    'promptly to ensure that no unauthorized activity occurs. Visit their website for their customer service phone numbers.'
  ].join('\n')
};
